<template>
  <Snackbar></Snackbar>
  <router-view />
  <PopupNotice
    :show="areYouThere"
    @logout="logout"
    @continue="handleContinue"
  />
</template>

<script>
import * as Sentry from "@sentry/vue";
import { useIdle } from "@vueuse/core";
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";

import PopupNotice from "@/components/PopupNotice.vue";
import Snackbar from "@/components/Snackbar.vue";
import authService from "@/services/auth.service";
import { useAuthStore } from "@/stores/auth";
import { useReemplazosStore } from "@/stores/reemplazos";
import { getDefaultRole } from "@/utils/userRoles";

export default defineComponent({
  name: "App",
  components: { Snackbar, PopupNotice },
  setup() {
    const { idle } = useIdle(30 * 60 * 1000); // 30 minutos
    const router = useRouter();
    const route = useRoute();
    // Stores
    const reemplazosStore = useReemplazosStore();
    const authStore = useAuthStore();

    return {
      idle,
      router,
      route,
      reemplazosStore,
      authStore,
    };
  },
  data() {
    return {
      areYouThere: false,
    };
  },
  watch: {
    "route.path"(newPath) {
      this.$eventBus.emit("navbar-to", newPath);
    },
    idle(newVal) {
      if (newVal) {
        this.areYouThere = true;
      }
    },
  },
  created() {
    this.$eventBus.on("loged", () => this.getSelf());
  },
  mounted() {
    // para que de tiempo al router de cambiar de route
    setTimeout(() => {
      this.getSelf();
    }, 100);
  },
  methods: {
    async getSelf() {
      try {
        const response = await this.$axios.get(
          this.$localurl + "/api/usuario/self",
        );
        if (response.data != "") {
          this.authStore.setUser(response.data);
          localStorage.setItem("token-landing", response.data.token);
          this.$forceUpdate();
          this.$eventBus.emit("update", response.data);
          this.setSentryUser(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    logout() {
      this.areYouThere = false;
      authService.logout();
    },
    handleContinue() {
      this.areYouThere = false;
    },
    setSentryUser(user) {
      if (this.$app_mode === "prod") {
        Sentry.getCurrentScope().setUser({
          id: user.id,
          email: user.email,
          username: user.nombre,
          role: getDefaultRole(user),
        });
      }
    },
  },
});
</script>

<style src="@/assets/css/reset.css"></style>
<style src="@/assets/css/fonts.css"></style>
<style src="@/assets/css/icons.css"></style>
<style src="@/assets/css/transitions.css"></style>
<style src="@/assets/css/app.css"></style>
<style src="@/assets/css/error.css"></style>
